module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper mb20"
  }, [_c('header', {
    staticClass: "gheader -white"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("戻る")])])]), (_vm.callbackflg) ? _c('div', {
    staticClass: "container user-post-detail",
    class: {
      '-adopt': _vm.isAdopt
    }
  }, [(_vm.proposeDetail.attributes['adopt-rank']) ? _c('div', {
    staticClass: "user-post-detail__label"
  }, [_c('div', {
    staticClass: "user-post-detail__label__wrap",
    class: '-' + _vm.proposeDetail.attributes['adopt-rank']
  }, [_c('div', {
    staticClass: "user-post-detail__label__wrap__content"
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['adopt-rank-conversion']))])])]) : _vm._e(), _c('div', {
    staticClass: "user-post-detail__head",
    on: {
      "click": function($event) {
        _vm.goProfileDetail(_vm.proposeDetail.attributes['user-id'])
      }
    }
  }, [_c('div', {
    staticClass: "user-outline -bg-thanks mb15"
  }, [(_vm.proposeDetail.attributes['profile-image-path']) ? _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.proposeDetail.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })]), _c('div', {
    staticClass: "user-outline__body"
  }, [_c('p', {
    staticClass: "user-outline__body__role"
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['shop-name']))]), _c('p', {
    staticClass: "user-outline__body__role"
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['user-type-name']))]), _c('h3', {
    staticClass: "user-outline__body__name"
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['user-name'] + ' ' + _vm.proposeDetail.attributes['user-firstname']))])])])]), _c('div', {
    staticClass: "user-post-detail__body"
  }, [(_vm.joint1User || _vm.joint2User) ? _c('div', {
    staticClass: "user-post-detail__body__others"
  }, [_c('p', {
    staticClass: "fz12 bold brown mb10"
  }, [_vm._v("一緒に提案している人")]), (_vm.joint1User) ? _c('div', {
    staticClass: "user-outline",
    on: {
      "click": function($event) {
        _vm.goProfileDetail(_vm.joint1User.id)
      }
    }
  }, [(_vm.joint1User.attributes['profile-image-path']) ? _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.joint1User.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })]), _c('div', {
    staticClass: "user-outline__body"
  }, [_c('p', {
    staticClass: "user-outline__body__role fz11"
  }, [_vm._v(_vm._s(_vm.joint1User.attributes['shop-name']) + " " + _vm._s(_vm.joint1User.attributes['user-type-name']))]), _c('h3', {
    staticClass: "user-outline__body__name fz16"
  }, [_vm._v(_vm._s(_vm.joint1User.attributes['user-name'] + ' ' + _vm.joint1User.attributes['user-firstname']))])])]) : _vm._e(), (_vm.joint2User) ? _c('div', {
    staticClass: "user-outline",
    on: {
      "click": function($event) {
        _vm.goProfileDetail(_vm.joint2User.id)
      }
    }
  }, [(_vm.joint2User.attributes['profile-image-path']) ? _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.joint2User.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png")
    }
  })]), _c('div', {
    staticClass: "user-outline__body"
  }, [_c('p', {
    staticClass: "user-outline__body__role fz11"
  }, [_vm._v(_vm._s(_vm.joint2User.attributes['shop-name']) + " " + _vm._s(_vm.joint2User.attributes['user-type-name']))]), _c('h3', {
    staticClass: "user-outline__body__name fz16"
  }, [_vm._v(_vm._s(_vm.joint2User.attributes['user-name'] + ' ' + _vm.joint2User.attributes['user-firstname']))])])]) : _vm._e()]) : _vm._e(), _c('p', {
    staticClass: "user-post-detail__body__time fz12 brown"
  }, [_vm._v(_vm._s(_vm.proposeDetail.attributes['contribution-at-format']))]), _c('h3', {
    staticClass: "user-post-detail__body__title fz16 bold brown",
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.proposeDetail.attributes['propose-title']))
    }
  }), _c('div', {
    staticClass: "user-post-detail__body__contents"
  }, [_c('p', {
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.proposeDetail.attributes['propose-content']))
    }
  }), (_vm.proposeDetail.attributes['propose-1-image-path']) ? _c('img', {
    attrs: {
      "src": _vm.proposeDetail.attributes['propose-1-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  }) : _vm._e(), (_vm.proposeDetail.attributes['propose-2-image-path']) ? _c('img', {
    attrs: {
      "src": _vm.proposeDetail.attributes['propose-2-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  }) : _vm._e(), (_vm.proposeDetail.attributes['propose-3-image-path']) ? _c('img', {
    attrs: {
      "src": _vm.proposeDetail.attributes['propose-3-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "user-post__body__like-btn",
    class: _vm.getGoodClass(_vm.proposeDetail.attributes['good-id']),
    on: {
      "click": function($event) {
        _vm.toggleGood(_vm.proposeDetail.id)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.proposeDetail.attributes['goods-count']))])])])]) : _vm._e(), (_vm.callbackflg && _vm.proposeDetail.attributes['adopt-content']) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "proposals-reply__post -user-detail mt20"
  }, [_vm._m(0), _c('div', {
    staticClass: "proposals-reply__post__body"
  }, [_vm._m(1), _c('div', {
    staticClass: "txt-box"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.proposeDetail.attributes['adopt-content']))
    }
  })])])])]) : (_vm.callbackflg && _vm.proposeDetail.attributes['approved-reason-content']) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "proposals-reply__post -user-detail mt20"
  }, [_vm._m(2), _c('div', {
    staticClass: "proposals-reply__post__body"
  }, [_vm._m(3), _c('div', {
    staticClass: "txt-box"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.proposeDetail.attributes['approved-reason-content']))
    }
  })])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "proposals-reply__post__thumb"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_tairanyan.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "proposals-reply__post__body__info"
  }, [_c('span', {
    staticClass: "proposals-reply__post__body__name"
  }, [_vm._v("提案ありがとうだニャン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "proposals-reply__post__thumb"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_tairanyan.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "proposals-reply__post__body__info"
  }, [_c('span', {
    staticClass: "proposals-reply__post__body__name"
  }, [_vm._v("提案ありがとうだニャン")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b522633c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose-detail.pug
// module id = 1454
// module chunks = 1